import { render, staticRenderFns } from "./Step2ComponentSign.vue?vue&type=template&id=0d2c55d7&"
import script from "./Step2ComponentSign.vue?vue&type=script&lang=js&"
export * from "./Step2ComponentSign.vue?vue&type=script&lang=js&"
import style0 from "./Step2ComponentSign.vue?vue&type=style&index=0&id=0d2c55d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports